<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/motel/topic_icon.svg" />
      <h1>General Hotels/<br class="mo_show" />Hostels</h1>
      <p>
        Offer a safe environment where customers
        <br />
        can stay comfortably.
      </p>
      <div class="topic-tags">
        <span class="tag"> #General Hotels </span>
        <span class="tag"> #Hostels </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/motel/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] General Hotels/Hostels"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_assurance.svg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
            <div class="title">
              <h3>Providing Customer Assurance</h3>
            </div>
            <p class="description">I need to provide a clean lodging environment and build a trustworthy image.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_cost.svg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
            <div class="title">
              <h3>Fixed Disinfection Cost Expenditure</h3>
            </div>
            <p class="description">I am concerned about the financial implications of mandatory regular disinfection for obligated facilities.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_nature.svg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
            <div class="title">
              <h3>Removal of Unpleasant Odors</h3>
            </div>
            <p class="description">I aim to eliminate the unpleasant odors in the establishment and create a luxurious fragrance.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>Relieve the burden of fixed costs with reasonably priced, customized pricing plans.</h4>
            <p>
              CESCO not only covers fixed disinfection costs but also offers comprehensive pest care through promotions designed with individual
              business owners in mind, providing reasonably priced, customized pricing.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/motel/border_content_01.png" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
          </div>
          <div>
            <img src="@/assets/images/location/motel/border_content_02.png" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
          </div>
          <div class="border-content">
            <h4>Enhance the elegance and quality of your space with tailored scent solutions.</h4>
            <p>
              From Airperfume, which provides a luxurious scent, to Airgenic, which automatically neutralises odours, create a unique space with
              CESCO's scent solutions. All solutions are tailored to your space.
            </p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Motels/General Hotels
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_air.svg" alt="CESCO [BusinessSectors] General Hotels/Hostels" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Air Quality
                  <br />
                  Assurance
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">This solution manages everything from ultrafine particles to radon radiation to ensure safety.</p>
            </div>

            <router-link to="/solution/service/air"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/motel/background_img_01.png'),
    products: [
      {
        posX: '52.5rem',
        posY: '19.995rem',
        mobilePosX: '66%',
        mobilePosY: '52%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/motel/background_img_02.png'),
    products: [
      {
        posX: '38.75rem',
        posY: '27.3075rem',
        mobilePosX: '51%',
        mobilePosY: '72%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_02.png'),
          name: 'CESCO\nYour Fit Bidet',
          description: 'A home-use bidet that achieves 99.99% sterilization and 99.9999% antibacterial effectiveness with electrolyzed water.'
        }
      },
      {
        posX: '47.375rem',
        posY: '10.4325rem',
        mobilePosX: '64%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_03.png'),
          name: 'CESCO\nAutomatic Toilet Cleaning Sterilizer Freshgenic',
          description: 'Cleans the toilet automatically by sterilizing 99.9% of harmful bacteria and removing 99.9% of odor-causing gases.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/motel/background_img_03.png'),
    products: [
      {
        posX: '13.375rem',
        posY: '25.995rem',
        mobilePosX: '18%',
        mobilePosY: '73%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_04.png'),
          name: 'CESCO\nAir Radon RoomCare Air Purifier SE',
          description: 'Continuously manages harmful substances such as ultrafine dust, radon, and CO2 in living rooms and bedrooms.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/motel/background_img_04.png'),
    products: [
      {
        posX: '33.25rem',
        posY: '5.37rem',
        mobilePosX: '44.5%',
        mobilePosY: '19%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_05.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/motel/background_img_05.png'),
    products: [
      {
        posX: '41.9375rem',
        posY: '13.62rem',
        mobilePosX: '56%',
        mobilePosY: '38%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },

  {
    backgroundImg: require('@/assets/images/location/motel/background_img_06.png'),
    products: [
      {
        posX: '32.5625rem',
        posY: '12.87rem',
        mobilePosX: '43%',
        mobilePosY: '36%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_06.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/motel/background_img_07.png'),
    products: [
      {
        posX: '42.9375rem',
        posY: '17.9325rem',
        mobilePosX: '60%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/motel/product_img_07.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - General Hotels/Hostels',
  meta: [
    {
      name: 'description',
      content: 'General Hotels/Hostels. Offer a safe environment where customers can stay comfortably.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
